<template>
  <Layout>
    <div class="content is-size-7 p-md">
      <GameTileList :games="games" />
    </div>
  </Layout>
</template>

<script>
import axios from 'axios'
import Layout from '@/layouts/GG'
import GameTileList from '@/components/LangGG/GameTileList'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTileList
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage) {
      const saleIdArr = window.location.hash.match(/\?saleId=([a-z0-9]+)/)
      if (saleIdArr instanceof Array && saleIdArr.length == 2) {
        window.localStorage.setItem('saleId', saleIdArr[1])
      }
    }
  },
  computed: {
    ...mapState({
      games: state => state.games.games
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/Home.vue